module.exports = __webpack_public_path__ + "img/red-warning.d87b6f16.svg";